export default __webpack_public_path__ + "static/media/train.e73c1350.svg";